exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.group-badge {\n  display: inline-block;\n  vertical-align: inherit;\n  margin-left: -25px;\n}\n", ""]);

// exports
